import {
  PreferredDegreeBackgroundEnum,
  PreferredWorkExperienceEnum,
} from '@/types/job-detail';

export const PREFERRED_DEGREE_BACKGROUND_MAP: Record<string, string> = {
  [PreferredDegreeBackgroundEnum.Doctor]: '博士',
  [PreferredDegreeBackgroundEnum.Master]: '硕士及以上',
  [PreferredDegreeBackgroundEnum.Bachelor]: '本科及以上',
  [PreferredDegreeBackgroundEnum.College]: '大专及以上',
  [PreferredDegreeBackgroundEnum.NoPreference]: '不限',
};

export const PREFERRED_WORK_EXPERIENCE_MAP: Record<string, string> = {
  [PreferredWorkExperienceEnum.None]: '不限',
  [PreferredWorkExperienceEnum.LessThanOne]: '1年以下',
  [PreferredWorkExperienceEnum.OneToThree]: '1-3年',
  [PreferredWorkExperienceEnum.ThreeToFive]: '3-5年',
  [PreferredWorkExperienceEnum.FiveToTen]: '5-10年',
  [PreferredWorkExperienceEnum.MoreThanTen]: '10年以上',
};

export const ACTIVE_TABS = [
  { en: 'analysis', title: '岗位解读' },
  { en: 'insight', title: '职位洞察' },
  { en: 'strategy', title: '应聘策略' },
  { en: 'promotion', title: '晋升发展' },
];

export const JOB_ANALYSIS_ITEMS = [
  {
    name: '如何解读这个岗位的工作内容',
    id: 'job-detail-analysis-job-content',
  },
  {
    name: '如何解读这个岗位的任职要求',
    id: 'job-detail-analysis-job-requirements',
  },
  {
    name: '如何解读这个岗位所需要的技能',
    id: 'job-detail-analysis-job-required-skills',
  },
];

export const JOB_INSIGHT_ITEMS = [
  {
    name: '此职位在公司怎么样？',
    id: 'job-detail-job-situation',
  },
  {
    name: '岗位潜在挑战与适配度分析',
    id: 'job-detail-job-potential-challenges',
  },
];
export const JOB_APPLICATION_STRATEGY_ITEMS = [
  {
    name: '核心应聘策略步骤',
    id: 'job-detail-recruitment-steps',
  },
  {
    name: '关键提醒',
    id: 'job-detail-key-reminders',
  },
];

export const JOB_PROMOTION_ITEMS = [
  {
    name: '岗位发展方向与成长路径预判',
    id: 'job-detail-development-direction',
  },
];
